import Vue from "vue";
import Router from "vue-router";

// Containers
import Cookies from "js-cookie";
import Full from "@/containers/Full";

/*****************************************************************************
 * OTTIMIZZATO SECONDO L'ARTICOLO:
 * https://vueschool.io/articles/vuejs-tutorials/vue-js-router-performance/
 *****************************************************************************
 */

// Views
import Dashboard from "@/views/Dashboard.vue";
import LoginForm from "@/views/LoginForm.vue";
import generalService from "../services/backendCipriani/generalService";
//import Recents from "@/views/Recents.vue";
//import ProjectView from "@/views/apps/ProjectView";
//import ProjectViewSwitcher from "@/views/apps/ProjectViewSwitcher";
//import CreateProjectView from "@/views/apps/CreateProjectView";
//import ArchiveManagementView from "@/views/SimplifiedArchiveManagement/SAMView";
//import TranslationsManagementView from "@/views/SimplifiedArchiveManagement/SAMTranslations";
//import RegisterForm from "@/views/RegisterForm.vue";
//import accessori from "@/views/OfferManagement/accessori";
//import mascheraFluidi from "@/views/OfferManagement/mascheraFluidi";
//import customerManagement from "@/views/CustomerManagement/CustomerManagement";
//import customerEdit from "@/views/CustomerManagement/CustomerEdit";
//import offerManagement from "@/views/OfferManagement/OfferManagement";
//import offerEdit from "@/views/OfferManagement/OfferEdit";
//import offerActive from "@/views/OfferManagement/OfferActive";
//import fluidManagement from "@/views/FluidManagement/FluidManagement";
//import fluidEdit from "@/views/FluidManagement/FluidEdit";
// import store from "@/store";

//import PrintView from "@/views/apps/PrintView";
//import ArchiveManagementView from "@/views/apps/ArchiveManagementView";

Vue.use(Router);

const forceLogin = false;

const router = new Router({
  mode: "hash",
  linkExactActiveClass: "open active",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      name: "Home",
      meta: {
        label: "S232"
      },
      component: Full,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          meta: {
            label: "S258"
          },
          component: Dashboard // () => import("@/views/Dashboard.vue")
        },
        {
          path: "print",
          name: "Print",
          component: () => import("@/views/Dashboard.vue")
        },
        {
          path: "options",
          name: "Options",
          component: () => import("@/views/Dashboard.vue")
        },
        {
          path: "recents",
          name: "Recents",
          component: () => import("@/views/Recents.vue")
        },
        {
          path: "management",
          name: "Management",
          component: () => import("@/views/SimplifiedArchiveManagement/SAMView")
        },
        {
          path: "translations",
          name: "Translations",
          component: () => import("@/views/SimplifiedArchiveManagement/SAMTranslations")
        },
        {
          path: "gestioneOfferte",
          name: "gestioneOfferte",
          component: () => import("@/views/OfferManagement/OfferManagement")
        },
        {
          path: "gestioneOfferte/active/",
          name: "activeOfferta",
          component: () => import("@/views/OfferManagement/OfferActive")
        },
        {
          path: "gestioneOfferte/Edit/:idOfferta",
          name: "editOfferta",
          component: () => import("@/views/OfferManagement/OfferEdit")
        },
        {
          path: "fluidManagement",
          name: "fluidManagement",
          component: () => import("@/views/FluidManagement/FluidManagement")
        },
        {
          path: "fluidManagement/edit/:fluidType/:idFluid",
          name: "fluidEdit",
          component: () => import("@/views/FluidManagement/FluidEdit")
        },
        {
          path: "gestioneClienti",
          name: "gestioneClienti",
          component: () => import("@/views/CustomerManagement/CustomerManagement")
        },
        {
          path: "gestioneClienti/Edit/:idCliente",
          name: "editCliente",
          component: () => import("@/views/CustomerManagement/CustomerEdit")
        },
        {
          path: "accessori",
          name: "accessori",
          component: () => import("@/views/OfferManagement/accessori")
        },
        {
          path: "mascheraFluidi",
          name: "mascheraFluidi",
          component: () => import("@/views/OfferManagement/mascheraFluidi")
        },
        {
          path: "create/project/:modality",
          name: "CreateProject",
          meta: {
            label: "S258"
          },
          component: () => import("@/views/apps/CreateProjectView")
        },
        {
          path: "project/:modality/:projectId/:offerId?/:offerRowId?",
          name: "ViewProject",
          meta: {
            label: "S258"
          },
          component: () => import("@/views/apps/ProjectView")
        },
        {
          path: "switch/project/:modality/:projectId",
          name: "SwitchProject",
          meta: {
            label: "S258"
          },
          component: () => import("@/views/apps/ProjectViewSwitcher")
        }
      ]
    },
    {
      path: "/login",
      component: LoginForm, // () => import("@/views/LoginForm.vue"),
      name: "LoginForm"
    },
    {
      path: "/maintenance",
      component: () => import("@/views/MaintenanceForm.vue"),
      name: "MaintenanceForm"
    },
    {
      path: "/privacy",
      component: () => import("@/views/CompliancePrivacy.vue"),
      name: "CompliancePrivacy"
    },
    {
      path: "/register",
      component: () => import("@/views/RegisterForm.vue"),
      name: "RegisterForm"
    }
  ]
});

//router.afterEach((/*to, from*/) => {
// Complete the animation of the route progress bar.
/*setTimeout(() => {
    NProgress.done();
  }, 300);*/
//});

//router.beforeResolve((to, from, next) => {
// If this isn't an initial page load.
/*if (to.name) {
    // Start the route progress bar.
    NProgress.start();
  }*/
//next();
//});

router.beforeEach((to, from, next) => {
  const isLoggedIn = Cookies.get("loginToken");
  console.log("----- FROM -> TO ---- ");
  console.log(from);
  console.log(to);

  //===========================================================================

  //MARCO DC 03/09/2021
  /*
  
    Adesso che viene aperte una nuova finestra ad ogni nuovo progetto/apertura di uno vecchio da offerta
    il path per arrivare al favicon viene resettato,

    in questo modo lo rimetto corretto

  
  */

  var base_url = document.querySelector("#CiprianiPath").value;
  document
    .getElementById("favicon")
    .setAttribute("href", base_url + "/Content/Cipriani/favicon.ico");

  //===========================================================================
  if (to.path != "/login" && to.path != "/register") {
    var bcontinue = isLoggedIn || forceLogin;

    if (bcontinue) {
      // 2020.09.25 - Marco DC mode
      //next();
      //------------------------------------
      if (to.path != "/privacy" && to.path != "/maintenance") {
        generalService
          .getMaintenanceStatus()
          .then(function(data) {
            var manutenzione = data;
            if (!manutenzione.privacy) {
              console.log(" -> Redirect -> privacy");
              next("/privacy");
            } else if (manutenzione.temporaryPass) {
              console.log(" -> Redirect -> login temporaryPass");
              next("/login");
            } else if (manutenzione.status) {
              console.log(" -> Redirect -> manutenzione");
              next("/maintenance");
            } else {
              console.log(" -> No Redirect -> Ok!");
              next();
            }
          })
          .catch(err => {
            //se c'è un errore in questo contesto credo che sia perchè è scaduta la password!
            next("/login");
          });
      } else {
        console.log(" -> No Redirect -> to.path == /privacy oppure /maintenance");
        next();
      }
      //------------------------------------
    } else {
      // console.warn('There is no token, redirect to login. (' + to.path + ')');
      console.log(" -> Redirect -> login ");
      next("/login");
    }

    //-------------
  } else {
    // console.log("You're on the login / register page");
    console.log(" -> No Redirect -> to.path == /login oppure /register");
    next(); // This is where it should have been
  }
});

export default router;
